module.exports = __webpack_public_path__ + "egencia-src-icon.png?f87d53700f2a04b5855a365ff096fa62";